import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState, useEffect } from 'react';
import { AISummariesStore } from './ai-summary-service/store';
import { AISummaryService } from './ai-summary-service';
export var useAISummary = function useAISummary(props) {
  var url = props.url;
  var aISummaryService = AISummariesStore.get(url);
  var isAISummaryServiceInitiated = !!aISummaryService;
  var _useState = useState(isAISummaryServiceInitiated ? aISummaryService.state : {
      status: 'ready',
      content: ''
    }),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  var isSummarised = isAISummaryServiceInitiated && state.status === 'done';
  useEffect(function () {
    if (!isSummarised) {
      var _AISummariesStore$get;
      if (!isAISummaryServiceInitiated) {
        AISummariesStore.set(url, new AISummaryService(props));
      }
      return (_AISummariesStore$get = AISummariesStore.get(url)) === null || _AISummariesStore$get === void 0 ? void 0 : _AISummariesStore$get.subscribe(setState);
    }
  }, [isSummarised, isAISummaryServiceInitiated, url, props]);
  var summariseUrl = function summariseUrl() {
    if (isAISummaryServiceInitiated) {
      return aISummaryService.summariseUrl();
    }
    return;
  };
  return {
    isSummarised: isSummarised,
    summariseUrl: summariseUrl,
    state: state
  };
};